import { createContext } from "react";
import { ListRowActionButtonsContextProps } from "./types";

const ListRowActionButtonsContext = createContext<ListRowActionButtonsContextProps>({});

ListRowActionButtonsContext.displayName = "ListRowActionButtonsContext";

export { ListRowActionButtonsContext };